<template>
    <div class="area-content-body admin-roles-contain">
        <div v-if="!canRead" class="no-permission-message">
            Sie haben keine Berechtigung, Rollen zu �ffnen.
        </div>

        <template v-else>
            <DxDataGrid class="admin-roles-grid"
                        :focused-row-enabled="true"
                        key-expr="_id"
                        :data-source="roles"
                        v-model:selectedRowKeys="selectedRole"
                        @selection-changed="selectionChanged">
                <DxColumn data-field="name" caption="Rolle" />
                <DxColumn data-field="description" caption="Beschreibung" />
                <DxColumn data-field="isSuperAdmin" caption="Super-Admin" data-type="boolean" />
                <DxSelection mode="single" />
            </DxDataGrid>

            <router-view @saved="fetchData"></router-view>
        </template>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import DxDataGrid, {
        DxColumn,
        DxSelection
    } from 'devextreme-vue/data-grid';
    import roleApi from '../services/RoleApi';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    export default defineComponent({
        components: {
            DxDataGrid,
            DxColumn,
            DxSelection
        },
        data() {
            return {
                roles: [],
                selectedRole: []
            };
        },
        computed: {
            canRead() {
                return meApi.hasPermissionSync(AppPermissions.AdminRoles.Read);
            },
            canWrite() {
                return meApi.hasPermissionSync(AppPermissions.AdminRoles.Write);
            },
            canDelete() {
                return meApi.hasPermissionSync(AppPermissions.AdminRoles.Delete);
            }
        },
        async created() {
            if (!this.canRead)
                return;

            await this.fetchData();
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler(id) {
                    if (!id || id === 'new') {
                        this.selectedRole = [];
                    } else {
                        this.selectedRole = [id];
                    }
                }
            }
        },
        methods: {
            async fetchData() {
                if (!this.canRead)
                    return;

                this.roles = (await roleApi.getAll()).sort((a, b) =>
                    (a.name || '').localeCompare(b.name || '')
                );

                if (!this.$route.params?.id && this.roles.length > 0) {
                    const firstRoleId = this.roles[0]._id;
                    this.selectedRole = [firstRoleId];
                    this.$router.replace('/Admin/Roles/' + firstRoleId);
                } else if (this.$route.params?.id) {
                    this.selectedRole = [this.$route.params.id];
                }
            },
            selectionChanged(e) {
                const id = e.selectedRowKeys?.[0];
                if (id && this.$route.params?.id !== id)
                    this.$router.push('/Admin/Roles/' + id);
            }
        }
    });
</script>

<style>
    .admin-roles-contain {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-gap: 10px;
        grid-template-rows: minmax(0, 1fr);
    }

    .admin-roles-grid .dx-datagrid {
        padding: 10px;
        background-color: #2a2a2a;
    }

    .no-permission-message {
        padding: 20px;
        background-color: #2a2a2a;
    }
</style>